var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 3V24H45C45 25.2634 44.886 26.5183 44.6625 27.75C44.1511 30.5674 43.0664 33.2641 41.4609 35.667C39.1534 39.1204 35.8736 41.812 32.0364 43.4015C28.1991 44.9909 23.9767 45.4068 19.9031 44.5965C15.8295 43.7862 12.0877 41.7861 9.15077 38.8492C6.21386 35.9123 4.21381 32.1705 3.40352 28.0969C2.59323 24.0233 3.0091 19.8009 4.59854 15.9636C6.18798 12.1264 8.8796 8.84665 12.333 6.53914C14.7359 4.93356 17.4326 3.84887 20.25 3.33752C21.4817 3.11397 22.7366 3 24 3ZM20.25 27.75H40.8375C40.3761 29.8215 39.534 31.801 38.3429 33.5836C36.4474 36.4203 33.7533 38.6313 30.6013 39.9369C27.4493 41.2425 23.9809 41.5841 20.6347 40.9185C17.2885 40.2529 14.2149 38.61 11.8024 36.1976C9.38996 33.7851 7.74706 30.7115 7.08146 27.3653C6.41587 24.0191 6.75748 20.5507 8.06309 17.3987C9.3687 14.2467 11.5797 11.5526 14.4164 9.65715C16.199 8.46604 18.1785 7.62392 20.25 7.16254V27.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8883 4.37017C31.7044 3.46558 29.3638 3 27 3V21L45 21C45 18.6362 44.5344 16.2956 43.6298 14.1117C42.7253 11.9278 41.3994 9.94353 39.7279 8.27208C38.0565 6.60062 36.0722 5.27475 33.8883 4.37017Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/presentation.bf54dc06d253324f5fc7be905249ecba.svg";
export { ForwardRef as ReactComponent };